import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { PartnerStateService } from '../../modules/partner/services/partner-state.service';

@Component({
  selector: 'app-page-registration',
  templateUrl: './page-registration.component.html',
  styleUrls: ['./page-registration.component.css']
})
export class PageRegistrationComponent implements OnInit {

  @ViewChild('partnerRegistrationForm', {static: true}) partnerRegistrationForm;

  constructor(
    private router: Router,
    private partnerStateService: PartnerStateService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit() {
    this.partnerRegistrationForm.showPassword = this.showPassword;
  }

  onBack() {
    this.router.navigate(['']);
  }

  onRegister() {
    this.partnerStateService.createPartner(
      this.partnerRegistrationForm.partner,
      this.partnerRegistrationForm.password.password
    ).subscribe(
      result => {
        if (result) {
          this.router.navigate(['thank_you']);
        } else {
          this.partnerRegistrationForm.error = 'Registration failed. Please try again later';
        }
      },
      (error) => {
        this.partnerRegistrationForm.error = error.message;
      }
    );
  }

  onLogin() {
    this.router.navigateByUrl('/login');
  }

  get allowedLogin(): boolean {
    return this.shopSettingsService.allowedLogin;
  }

  get showPassword(): boolean {
    return this.shopSettingsService.showRegistrationPassword;
  }

}
